import ko from "knockout";
import _ from "lodash";
import Promise from "bluebird";
import $ from "jquery";
import apiCore from "services/apiCore";
import authService from "services/authService";
import Queue from "models/Queue";
import User from "models/User";

const BASE_URI = "/routing/queues";
const BRIEF_URI = "/routing/queues/divisionviews";

function getGroupsUri(queueId) {
    return BASE_URI + "/" + queueId + "/groups";
}

function getUsersUri(queueId) {
    return BASE_URI + "/" + queueId + "/users";
}

function getUserUri(queueId, memberId) {
    return getGroupsUri(queueId) + "/" + memberId;
}

export default {
    getQueues(options, formatOptions) {
        const parameters = _.assign(
            {
                pageNumber: 1,
                pageSize: 25,
            },
            options
        );

        if (_.has(parameters, "name")) {
            // Add a wildcard to the results
            parameters.name = "*" + $.trim(parameters.name) + "*";
        }

        const format = _.assign(
            {
                returnModels: true,
            },
            formatOptions
        );

        return apiCore.v2.get(BASE_URI, parameters).then(function (response) {
            const results = response;

            if (!format.returnModels) {
                return results;
            } else {
                results.entities = _.map(
                    response.entities,
                    function convertToQueueObj(data) {
                        return new Queue(data);
                    }
                );

                return results;
            }
        });
    },

    getQueue(queueId, formatOptions) {
        const format = _.assign(
            {
                returnModel: true,
            },
            formatOptions
        );
        const id = ko.unwrap(queueId);

        return apiCore.v2.get(BASE_URI + "/" + id).then(function (response) {
            return format.returnModel ? new Queue(response) : response;
        });
    },
    getQueuesBrief(options) {
        if (!authService.hasAuthorization("perm:routing:queue:search")) {
            return Promise.reject(
                new Error("Permission routing:queue:search needed")
            );
        }

        const parameters = _.assign(
            {
                pageNumber: 1,
                pageSize: 25,
            },
            options
        );

        return apiCore.v2.get(BRIEF_URI, parameters).then(function (response) {
            return response;
        });
    },
    getUsers(queueId, options) {
        options = _.assign(
            { pageSize: 25, pageNumber: 1, expand: "routingStatus" },
            options
        );

        if (_.has(options, "name")) {
            // Add a wildcard to the results
            options.name = "*" + $.trim(options.name) + "*";
        }

        return apiCore.v2.get(getUsersUri(queueId), options);
    },
    updateUsers(queueId, users) {
        return apiCore.v2.patch(getUsersUri(queueId), users);
    },
    updateUser(queueId, user) {
        return apiCore.v2.patch(getUserUri(queueId, user.id), user);
    },
    getMyQueues(options) {
        options = _.assign({ pageSize: 25, pageNumber: 1 }, options);
        return apiCore.v2.get(BASE_URI + "/me", options);
    },
    getUserQueues(userId, options) {
        options = _.assign({ pageSize: 25, pageNumber: 1 }, options);
        return apiCore.v2.get("/users/" + userId + "/queues", options);
    },
    updateUserJoinedQueues(userId, queues) {
        return apiCore.v2.patch("/users/" + userId + "/queues", queues);
    },
};
